import React, { useCallback, useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { getCurrenciesList } from '../../../Reducers/accounts';
import useBoolean from '../../../Utils/useBoolean';
import { Button, Drawer, Form, Input, message } from 'antd';
import { ReadOutlined } from '@ant-design/icons';
import './styles.scss'
import { bunchDearchive } from '../../../Reducers/archiveAccounts';

const DearchiveFormDrawer = ({ afterUpdate }) => {

  const { value: isOpen, setFalse: close, setTrue: open } = useBoolean(false);

  const [form] = Form.useForm();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCurrenciesList())
  }, [dispatch])

  const { payload } = useSelector(state => state.accounts.currencies, shallowEqual);

  const handleSuccess = useCallback((formData) => {
    const processedData = Object.entries(formData).reduce((acc, [key, value]) => {
      if (value !== undefined && value !== '') { 
        acc[key] = isNaN(value) ? value : Number(value);
      }
      return acc;
    }, {});

    dispatch(bunchDearchive(processedData))
    .then((res) => {
      console.log(`res: ${res}`)
      if (res.includes("Nothing")) {
        message.error(`Nothing found to dearchive!`)
      } else {
        message.success(`Dearchiving ${res}`);
        form.resetFields();
        close();
        afterUpdate();
      }
    })
    .catch((error) => {
      message.error(`Failed to dearchive: ${error}`)
    })

    
  }, [dispatch, afterUpdate]);

  return (
    <>
    <Drawer open={isOpen} title={`Return accounts from acrhive`} width={500} closable placement="right" onClose={close}>
        <Form 
        layout="vertical"
        form={form}
        onFinish={handleSuccess}
        >
          {payload?.map((value) => 
          <div className='dearchive_form__inputs'>
          <Form.Item name={value}>
            <Input addonBefore={value} type="number" />
          </Form.Item>
        </div>
          )}
          <Form.Item>
            <Button
                  type="primary"
                  htmlType="submit"
              >
                  Submit
              </Button>
          </Form.Item>
        </Form>
    </Drawer>
    <Button
    type="primary"
    icon={<ReadOutlined />}
    onClick={open}
  >Dearchive accounts</Button>
  </>
  )
}

export default DearchiveFormDrawer
